// extracted by mini-css-extract-plugin
export var root = "ending-today-module--root--1Djv1";